{
  "everyone": "Everyone",
  "unknown_member": "Unknown",
  "edit_message": "Edit message",
  "delete_message": "Delete message",
  "delete_confirm": "Confirm delete",
  "delete_cancel": "Cancel"
}
